<script lang="ts">
    
    import { Badge, Icon } from "sveltestrap";

    export let text = 'Activado';

</script>

<Badge color="success">
    <Icon name="check2" /> {text}
</Badge>
